/** Get Dashboard data */
export const API_SUCCESS = "API_SUCCESS";
export const API_FAIL = "API_FAIL";
export const GET_USERS_DATA = 'GET_USERS_DATA';
export const CREATE_USER = 'CREATE_USER';
export const CREATE_USER_SUCCESS = 'CREATE_USER_SUCCESS';
export const CREATE_USER_FAIL = 'CREATE_USER_FAIL';
export const CLEAR_ERRORS = 'CLEAR_ERRORS';



export const GET_USER = "GET_USER"
export const GET_USER_SUCCESS = "GET_USER_SUCCESS"
export const GET_USER_FAIL = "GET_USER_FAIL"

export const UPDATE_SUPER_USER_SUCCESS = 'UPDATE_SUPER_USER_SUCCESS';
export const UPDATE_SUPER_USER_FAIL = 'UPDATE_SUPER_USER_FAIL';

export const DELETE_USER = 'DELETE_USER';
export const DELETE_USER_SUCCESS = 'DELETE_USER_SUCCESS';
export const DELETE_USER_FAIL = 'DELETE_USER_FAIL';

export const UPDATE_USER_DATA = 'UPDATE_USER_DATA';
export const UPDATE_USER = 'UPDATE_USER';
export const UPDATE_USER_SUCCESS = 'UPDATE_USER_SUCCESS';
export const UPDATE_USER_FAIL = 'UPDATE_USER_FAIL';

export const GET_DOMAINS_REQUEST = "GET_DOMAINS_REQUEST";
export const GET_DOMAINS_SUCCESS = "GET_DOMAINS_SUCCESS";
export const GET_DOMAINS_FAILURE = "GET_DOMAINS_FAILURE";

export const GET_ADMIN_DASHBOARD_SUMMARY_REQUEST = "GET_ADMIN_DASHBOARD_SUMMARY_REQUEST";
export const GET_ADMIN_DASHBOARD_SUMMARY_SUCCESS = "GET_ADMIN_DASHBOARD_SUMMARY_SUCCESS";
export const GET_ADMIN_DASHBOARD_SUMMARY_FAILURE = "GET_ADMIN_DASHBOARD_SUMMARY_FAILURE";

export const GET_ADMIN_DASHBOARD_SIGNUPS_REQUEST = "GET_ADMIN_DASHBOARD_SIGNUPS_REQUEST";
export const GET_ADMIN_DASHBOARD_SIGNUPS_SUCCESS = "GET_ADMIN_DASHBOARD_SIGNUPS_SUCCESS";
export const GET_ADMIN_DASHBOARD_SIGNUPS_FAILURE = "GET_ADMIN_DASHBOARD_SIGNUPS_FAILURE";

export const GET_ADMIN_DASHBOARD_DOCS_MONTHLY_REQUEST = "GET_ADMIN_DASHBOARD_DOCS_MONTHLY_REQUEST";
export const GET_ADMIN_DASHBOARD_DOCS_MONTHLY_SUCCESS = "GET_ADMIN_DASHBOARD_DOCS_MONTHLY_SUCCESS";
export const GET_ADMIN_DASHBOARD_DOCS_MONTHLY_FAILURE = "GET_ADMIN_DASHBOARD_DOCS_MONTHLY_FAILURE";

export const GET_ADMIN_DASHBOARD_COMPANY_TYPES_REQUEST = "GET_ADMIN_DASHBOARD_COMPANY_TYPES_REQUEST";
export const GET_ADMIN_DASHBOARD_COMPANY_TYPES_SUCCESS = "GET_ADMIN_DASHBOARD_COMPANY_TYPES_SUCCESS";
export const GET_ADMIN_DASHBOARD_COMPANY_TYPES_FAILURE = "GET_ADMIN_DASHBOARD_COMPANY_TYPES_FAILURE";

export const GET_ADMIN_DASHBOARD_ACTIVE_SESSIONS_REQUEST = "GET_ADMIN_DASHBOARD_ACTIVE_SESSIONS_REQUEST";
export const GET_ADMIN_DASHBOARD_ACTIVE_SESSIONS_SUCCESS = "GET_ADMIN_DASHBOARD_ACTIVE_SESSIONS_SUCCESS";
export const GET_ADMIN_DASHBOARD_ACTIVE_SESSIONS_FAILURE = "GET_ADMIN_DASHBOARD_ACTIVE_SESSIONS_FAILURE";

export const GET_ME_DASHBOARD_SUMMARY_REQUEST = "GET_ME_DASHBOARD_SUMMARY_REQUEST";
export const GET_ME_DASHBOARD_SUMMARY_SUCCESS = "GET_ME_DASHBOARD_SUMMARY_SUCCESS";
export const GET_ME_DASHBOARD_SUMMARY_FAILURE = "GET_ME_DASHBOARD_SUMMARY_FAILURE";

export const GET_ME_DASHBOARD_DAILY_DOCS_REQUEST = "GET_ME_DASHBOARD_DAILY_DOCS_REQUEST";
export const GET_ME_DASHBOARD_DAILY_DOCS_SUCCESS = "GET_ME_DASHBOARD_DAILY_DOCS_SUCCESS";
export const GET_ME_DASHBOARD_DAILY_DOCS_FAILURE = "GET_ME_DASHBOARD_DAILY_DOCS_FAILURE";

export const GET_ME_DASHBOARD_DOCS_MONTHLY_REQUEST = "GET_ME_DASHBOARD_DOCS_MONTHLY_REQUEST";
export const GET_ME_DASHBOARD_DOCS_MONTHLY_SUCCESS = "GET_ME_DASHBOARD_DOCS_MONTHLY_SUCCESS";
export const GET_ME_DASHBOARD_DOCS_MONTHLY_FAILURE = "GET_ME_DASHBOARD_DOCS_MONTHLY_FAILURE";

export const GET_ME_DASHBOARD_TOP_TYPES_REQUEST = "GET_ME_DASHBOARD_TOP_TYPES_REQUEST";
export const GET_ME_DASHBOARD_TOP_TYPES_SUCCESS = "GET_ME_DASHBOARD_TOP_TYPES_SUCCESS";
export const GET_ME_DASHBOARD_TOP_TYPES_FAILURE = "GET_ME_DASHBOARD_TOP_TYPES_FAILURE";

export const GET_ASSESSMENTS_DATA= "GET_ASSESSMENTS";
export const ADD_ASSESSMENT = "ADD_ASSESSMENT";
export const ADD_ASSESSMENT_SUCCESS = "ADD_ASSESSMENT_SUCCESS";
export const ADD_ASSESSMENT_FAIL = "ADD_ASSESSMENT_FAIL";

export const ASSESSMENT_API_SUCCESS = "ASSESSMENT_API_SUCCESS";
export const ASSESSMENT_API_FAIL = "ASSESSMENT_API_FAIL";
export const UPDATE_ASSESSMENT_DATA = 'UPDATE_ASSESSMENT_DATA';
export const UPDATE_ASSESSMENT_SUCCESS = 'UPDATE_ASSESSMENT_SUCCESS';
export const UPDATE_ASSESSMENT_FAIL = 'UPDATE_ASSESSMENT_FAIL';
export const STEP_BACK = 'STEP_BACK';
export const CLEAR_ASSESSMENT_ID = 'CLEAR_ASSESSMENT_ID';
export const STEP_NEXT = 'STEP_NEXT';
export const GO_TO_DASHBOARD = 'GO_TO_DASHBOARD';

export const CLONE_ASSESSMENT = 'CLONE_ASSESSMENT';
export const CLONE_ASSESSMENT_SUCCESS = 'CLONE_ASSESSMENT_SUCCESS';
export const CLONE_ASSESSMENT_FAIL = 'CLONE_ASSESSMENT_FAIL';

export const DELETE_ASSESSMENT = 'DELETE_ASSESSMENT';
export const DELETE_ASSESSMENT_SUCCESS = 'DELETE_ASSESSMENT_SUCCESS';
export const DELETE_ASSESSMENT_FAIL = 'DELETE_ASSESSMENT_FAIL';

export const CREATE_PATIENT = 'CREATE_PATIENT';
export const CREATE_PATIENT_SUCCESS = 'CREATE_PATIENT_SUCCESS';
export const CREATE_PATIENT_FAIL = 'CREATE_PATIENT_FAIL';

export const GET_PATIENT_DATA = 'GET_PATIENT_DATA';
export const GET_PATIENT_DATA_SUCCESS = 'GET_PATIENT_DATA_SUCCESS';
export const GET_PATIENT_DATA_FAIL = 'GET_PATIENT_DATA_FAIL';

export const UPDATE_PATIENT = 'UPDATE_PATIENT';
export const UPDATE_PATIENT_SUCCESS = 'UPDATE_PATIENT_SUCCESS';
export const UPDATE_PATIENT_FAIL = 'UPDATE_PATIENT_FAIL';

export const DELETE_PATIENT = 'DELETE_PATIENT';
export const DELETE_PATIENT_SUCCESS = 'DELETE_PATIENT_SUCCESS';
export const DELETE_PATIENT_FAIL = 'DELETE_PATIENT_FAIL';
